<template>
  <div class="filter">
    <Multiselect label="Database" :value="value.database" :options="databases" @input="updateDatabase" />
    <Multiselect v-if="value.database" label="Field" :value="value.field" :options="fieldOptions" @input="updateField" />
    <Multiselect v-if="value.field" label="Operator" :value="value.operator" :options="operatorOptions" @input="updateOperator" />
    <FilterControl
      v-if="value.operator && value.operator !== 'is empty' && value.operator !== 'is not empty'"
      :value="value.value"
      :settings="fieldSettings"
      :operator="value.operator"
      @input="$emit('input', { ...value, value: $event })"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Multiselect from '@/components/common/Multiselect.vue';
import FilterControl from './filter-controls/FilterControl.vue';
export default {
  name: 'PipelineFilter',
  components: {
    Multiselect,
    FilterControl
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    filterSettings() {
      return this.$store.state.pipelines.settings || [];
    },
    databases() {
      return this.filterSettings.map(setting => setting.database);
    },
    selectedFilterSetting() {
      return this.filterSettings.find(setting => setting.database === this.value.database);
    },
    fieldOptions() {
      return this.selectedFilterSetting ? Object.keys(this.selectedFilterSetting.fields) : [];
    },
    fieldSettings() {
      if (!this.selectedFilterSetting || !this.value.field) {
        return null;
      }
      return this.selectedFilterSetting.fields[this.value.field];
    },
    operatorOptions() {
      const settings = this.fieldSettings;
      if (!settings) {
        return [];
      }

      if (settings.options) {
        return ['equals', 'not equals', 'is empty', 'is not empty'];
      }
      switch (settings.type) {
        case 'string':
          return ['equals', 'not equals', 'contains', 'does not contain', 'is empty', 'is not empty'];
        case 'number':
          return ['equals', 'not equals', 'greater than', 'less than', 'is empty', 'is not empty'];
        case 'date':
          return ['before', 'after', 'on', 'is empty', 'is not empty'];
        case 'boolean':
          return ['is true', 'is false', 'is empty', 'is not empty'];
        case 'array':
          return ['contains', 'does not contain', 'is empty', 'is not empty'];
        default:
          return [];
      }
    }
  },
  methods: {
    updateDatabase(newDatabase) {
      this.$emit('input', { ...this.value, database: newDatabase, field: null, operator: null, value: null });
    },
    updateField(newField) {
      this.$emit('input', { ...this.value, field: newField, operator: null, value: null });
    },
    updateOperator(newOperator) {
      this.$emit('input', { ...this.value, operator: newOperator, value: null });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}
</style>
